"use client";

// src/components/banner/index.tsx
import React6 from "react";
import { motion as motion4, AnimatePresence } from "motion/react";
import { banner } from "@pinatagrams/design-system/recipes";

// src/components/button/index.tsx
import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { button } from "@pinatagrams/design-system/recipes";
import { motion } from "motion/react";
import { useCallback } from "react";

// src/components/button/motion.ts
import { DURATION, OPACITY } from "@pinatagrams/design-system";
var variants = {
  bold: {
    disabled: {
      opacity: OPACITY.disabled
    },
    rest: {
      y: "0"
    },
    rise: {
      y: "-.25rem"
    },
    active: {
      y: "-.25rem",
      transition: {
        duration: DURATION.rapid
      }
    },
    focus: {
      y: "-.25rem",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  subtle: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  DEFAULT: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  ghost: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  loud: {
    disabled: {
      opacity: OPACITY.disabled
    },
    rest: {
      scaleX: "100%",
      scaleY: "100%"
    },
    rise: {
      scaleX: "110%",
      scaleY: "90%"
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  }
};

// src/components/button/sound/click.mp3
var click_default = "data:audio/mpeg;base64,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";

// src/components/button/sound/release.mp3
var release_default = "data:audio/mpeg;base64,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";

// src/components/button/index.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var MotionSlot = motion(Slot);
var Button = React.forwardRef(
  ({ emphasis, children, size = "md", icons, disabled, asChild, className, style, ...props }, ref) => {
    const { onBlur, onFocus, onMouseDown, onMouseUp } = props;
    const buttonClassName = button({ emphasis, size });
    const mergedClassName = className ? `${buttonClassName} ${className}` : buttonClassName;
    const buttonRef = React.useRef(null);
    const audioRef = React.useRef(null);
    const LeftIcon = icons?.[0];
    const RightIcon = icons?.[1];
    const setRefs = useCallback(
      (node) => {
        buttonRef.current = node;
        if (typeof ref === "function") {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      },
      [ref]
    );
    const audioButtonPress = useCallback((state) => {
      audioRef.current = new Audio(state === "click" ? click_default : release_default);
      const playPromise = audioRef.current.play();
      if (playPromise instanceof Promise) {
        playPromise.catch((error) => {
          console.error("Error playing audio:", error);
        });
      }
    }, []);
    const handleOnMouseDown = useCallback(
      (event) => {
        onMouseDown?.(event);
        audioButtonPress("click");
      },
      [onMouseDown, audioButtonPress]
    );
    const handleOnMouseUp = useCallback(
      (event) => {
        onMouseUp?.(event);
        audioButtonPress("release");
      },
      [onMouseUp, audioButtonPress]
    );
    const handleOnFocus = useCallback(
      (event) => {
        onFocus?.(event);
      },
      [onFocus]
    );
    const handleOnBlur = useCallback(
      (event) => {
        onBlur?.(event);
      },
      [onBlur]
    );
    const Component = asChild ? MotionSlot : motion.button;
    const content = asChild ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
      LeftIcon && /* @__PURE__ */ jsx(LeftIcon, {}),
      children,
      RightIcon && /* @__PURE__ */ jsx(RightIcon, {})
    ] });
    return /* @__PURE__ */ jsx(
      Component,
      {
        ref: setRefs,
        className: mergedClassName,
        style,
        transition: {
          duration: 0.2,
          ease: "linear"
        },
        variants: variants[emphasis] || variants["DEFAULT"],
        initial: "rest",
        animate: disabled ? "disabled" : "rest",
        whileHover: "rise",
        whileTap: "active",
        whileFocus: "focus",
        layout: "position",
        onMouseDown: handleOnMouseDown,
        onMouseUp: handleOnMouseUp,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        disabled: asChild ? void 0 : disabled,
        ...props,
        children: content
      }
    );
  }
);
Button.displayName = "Button";
var button_default = Button;

// src/components/text/index.tsx
import React2 from "react";
import { textRecipe } from "@pinatagrams/design-system/recipes";
import { jsx as jsx2 } from "react/jsx-runtime";
var Title = React2.forwardRef(
  ({ hierarchy = "title", emphasis = "strong", className, children, ...props }, ref) => {
    const slots = textRecipe({ hierarchy, titleEmphasis: emphasis });
    const cls = slots.title;
    const Tag = hierarchy === "splash" ? "h1" : hierarchy === "subtitle" ? "h3" : "h2";
    return (
      // @ts-expect-error dynamic heading tag
      /* @__PURE__ */ jsx2(Tag, { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children })
    );
  }
);
Title.displayName = "Title";
var Body = React2.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ bodyEmphasis: emphasis });
    const cls = slots.body;
    return /* @__PURE__ */ jsx2("p", { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children });
  }
);
Body.displayName = "Body";
var Supplemental = React2.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ supplementalEmphasis: emphasis });
    const cls = slots.supplemental;
    return /* @__PURE__ */ jsx2(
      "code",
      {
        ref,
        className: [cls, className].filter(Boolean).join(" "),
        ...props,
        children
      }
    );
  }
);
Supplemental.displayName = "Supplemental";

// src/components/tooltip/index.tsx
import React4 from "react";
import { Tooltip as TT } from "radix-ui";
import { tooltip } from "@pinatagrams/design-system/recipes";
import { motion as motion2 } from "motion/react";

// src/contexts/layer-context.tsx
import React3 from "react";

// src/contexts/layer-types.ts
var LayerType = /* @__PURE__ */ ((LayerType2) => {
  LayerType2[LayerType2["Main"] = 0] = "Main";
  LayerType2[LayerType2["Nav"] = 1] = "Nav";
  LayerType2[LayerType2["Popover"] = 2] = "Popover";
  LayerType2[LayerType2["Toasts"] = 3] = "Toasts";
  LayerType2[LayerType2["Overlay"] = 4] = "Overlay";
  return LayerType2;
})(LayerType || {});
var layerNameMap = {
  main: 0 /* Main */,
  nav: 1 /* Nav */,
  popover: 2 /* Popover */,
  toasts: 3 /* Toasts */,
  overlay: 4 /* Overlay */
};

// src/contexts/layer-context.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var LayerContext = React3.createContext(null);
function Wrapper({
  children,
  layer
}) {
  const context = React3.useContext(LayerContext);
  if (!context) {
    throw new Error("[Layer] Layer.Wrapper must be used within Layer");
  }
  const resolvedLayer = typeof layer === "string" ? layerNameMap[layer] : layer;
  const nextLayer = resolvedLayer >= context.layer ? resolvedLayer : context.layer;
  return /* @__PURE__ */ jsx3(LayerContext.Provider, { value: { ...context, layer: nextLayer }, children });
}
function LayerRoot({ children }) {
  const baseLayerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
  return /* @__PURE__ */ jsxs2(LayerContext.Provider, { value: { layer: 0 /* Main */ }, children: [
    /* @__PURE__ */ jsx3("style", { children: `
				[data-layer] > * {
					pointer-events: auto;
				}
			` }),
    /* @__PURE__ */ jsx3("section", { id: "layer-popover", style: { ...baseLayerStyle, zIndex: 2 }, "data-layer": "popover" }),
    /* @__PURE__ */ jsx3("section", { id: "layer-toasts", style: { ...baseLayerStyle, zIndex: 3 }, "data-layer": "toasts" }),
    /* @__PURE__ */ jsx3(
      "section",
      {
        id: "layer-overlay",
        style: {
          ...baseLayerStyle,
          zIndex: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        "data-layer": "overlay"
      }
    ),
    children
  ] });
}
function useLayerContainer(overrideLayer) {
  const context = React3.useContext(LayerContext);
  const [container, setContainer] = React3.useState(void 0);
  React3.useLayoutEffect(() => {
    const defaultContainer = document.getElementById("layer-popover");
    if (!defaultContainer) {
      throw new Error("[Layer] Missing default popover layer container");
    }
    if (!context) return setContainer(defaultContainer);
    let targetLayer = context.layer;
    if (overrideLayer !== void 0) {
      targetLayer = overrideLayer >= context.layer ? overrideLayer : context.layer;
    }
    if (targetLayer === 0 /* Main */ || targetLayer === 1 /* Nav */) {
      setContainer(defaultContainer);
      return;
    }
    const layerId = LayerType[targetLayer].toLowerCase();
    const element = document.getElementById(`layer-${layerId}`);
    if (!element) {
      throw new Error(`[Layer] Missing container for layer: ${layerId}`);
    }
    setContainer(element);
  }, [context, overrideLayer]);
  return container;
}
var Layer = Object.assign(LayerRoot, { Wrapper });

// src/components/tooltip/index.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var TooltipProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx4(TT.Provider, { ...props, children });
};
var TooltipRoot = ({
  children,
  open,
  onOpenChange,
  delayDuration = 0
}) => {
  const [isOpen, setIsOpen] = React4.useState(open ?? false);
  React4.useEffect(() => {
    if (open !== void 0) {
      setIsOpen(open);
    }
  }, [open]);
  const handleOpenChange = (newOpen) => {
    setIsOpen(newOpen);
    onOpenChange?.(newOpen);
  };
  return /* @__PURE__ */ jsx4(TT.Root, { delayDuration, open: isOpen, onOpenChange: handleOpenChange, children });
};
var TooltipTrigger = ({ children }) => {
  const triggerElement = React4.isValidElement(children) ? children : /* @__PURE__ */ jsx4("span", { children });
  return /* @__PURE__ */ jsx4(TT.Trigger, { asChild: true, children: triggerElement });
};
var TooltipContent = ({
  children,
  side = "top",
  sideOffset = 10,
  cardClassName,
  ...props
}) => {
  const container = useLayerContainer(2 /* Popover */);
  const MotionContent = React4.forwardRef((motionProps, ref) => /* @__PURE__ */ jsx4(motion2.div, { ref, ...motionProps }));
  MotionContent.displayName = "MotionContent";
  return /* @__PURE__ */ jsx4(TT.Portal, { container, children: /* @__PURE__ */ jsx4(TT.Content, { side, sideOffset, ...props, children: /* @__PURE__ */ jsxs3(
    MotionContent,
    {
      className: tooltip().root,
      initial: { opacity: 0, y: 20, scale: 0.8 },
      animate: { opacity: 1, y: 0, scale: 1 },
      exit: {
        opacity: 0,
        y: 20,
        scale: 0.8,
        transition: { duration: 0.1 }
      },
      children: [
        /* @__PURE__ */ jsx4("div", { className: `${tooltip().card}${cardClassName ? ` ${cardClassName}` : ""}`, children }),
        /* @__PURE__ */ jsx4(TT.Arrow, { className: "tooltip-arrow" })
      ]
    }
  ) }) });
};
var Tooltip = Object.assign(TooltipRoot, {
  Trigger: TooltipTrigger,
  Content: TooltipContent,
  Provider: TooltipProvider
});
var tooltip_default = Tooltip;

// src/components/banner/index.tsx
import {
  CheckCircleIcon,
  WarningIcon,
  SmileyXEyesIcon,
  InfoIcon,
  XCircleIcon
} from "@phosphor-icons/react";

// src/components/layout/index.tsx
import React5 from "react";
import { motion as motion3 } from "motion/react";
import {
  stackLayout,
  rowLayout,
  pageSection,
  pageHeader,
  actionHeader,
  gridLayout,
  mainLayout,
  backdrop,
  scrollContainer
} from "@pinatagrams/design-system/recipes";
import { DURATION as DURATION2, EASING } from "@pinatagrams/design-system";
import { jsx as jsx5 } from "react/jsx-runtime";
var Stack = React5.forwardRef(
  ({ gap = "md", align = "stretch", skeleton = false, className, ...props }, ref) => {
    const { root } = stackLayout({ gap, align, skeleton });
    return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Stack.displayName = "Stack";
var Inline = React5.forwardRef(
  ({ gap = "md", align = "center", justify = "start", wrap = true, className, ...props }, ref) => {
    const { root } = rowLayout({ gap, align, justify, wrap });
    return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Inline.displayName = "Inline";
var PageSection = React5.forwardRef(
  ({ maxWidth = "lg", className, ...props }, ref) => {
    const { root } = pageSection({ maxWidth });
    return /* @__PURE__ */ jsx5("section", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
PageSection.displayName = "PageSection";
var PageHeader = React5.forwardRef(
  ({ className, ...props }, ref) => {
    const { root } = pageHeader({});
    return /* @__PURE__ */ jsx5("header", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
PageHeader.displayName = "PageHeader";
var HeaderRoot = React5.forwardRef(
  ({ sticky = false, skeleton = false, className, ...props }, ref) => {
    const { root } = actionHeader({ sticky, skeleton });
    return /* @__PURE__ */ jsx5("header", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
HeaderRoot.displayName = "Header";
var HeaderTitleSection = React5.forwardRef(({ className, ...props }, ref) => {
  const { title } = actionHeader({});
  return /* @__PURE__ */ jsx5("div", { ref, className: `${title}${className ? ` ${className}` : ""}`, ...props });
});
HeaderTitleSection.displayName = "Header.Title";
var HeaderActionsSection = React5.forwardRef(({ className, ...props }, ref) => {
  const { actions } = actionHeader({});
  return /* @__PURE__ */ jsx5("div", { ref, className: `${actions}${className ? ` ${className}` : ""}`, ...props });
});
HeaderActionsSection.displayName = "Header.Actions";
var Header = Object.assign(HeaderRoot, {
  Title: HeaderTitleSection,
  Actions: HeaderActionsSection
});
var Main = React5.forwardRef(
  ({ gap = "lg", padding = "lg", skeleton = false, className, ...props }, ref) => {
    const { root } = mainLayout({ gap, padding, skeleton });
    return /* @__PURE__ */ jsx5("main", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Main.displayName = "Main";
var Grid = React5.forwardRef(
  ({
    gap = "md",
    justify = "center",
    align = "start",
    items = "center",
    overflow = "auto",
    flex = "fill",
    padding = "lg",
    className,
    ...props
  }, ref) => {
    const { root } = gridLayout({ gap, justify, align, items, overflow, flex, padding });
    return /* @__PURE__ */ jsx5("section", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Grid.displayName = "Grid";
var Overlay = React5.forwardRef(
  ({ status, origin, pos, elevation, size, children, exited }, ref) => {
    const coords = origin || pos;
    const maskType = origin ? "origin" : pos !== void 0 ? "pos" : void 0;
    const { root } = backdrop({ status, elevation, size });
    return /* @__PURE__ */ jsx5(
      motion3.div,
      {
        ref,
        className: root,
        variants: getBackdropVariants(coords, maskType, exited),
        custom: coords,
        initial: "closed",
        animate: "open",
        exit: "closed",
        children
      }
    );
  }
);
Overlay.displayName = "Overlay";
var getBackdropVariants = (coords, maskType, exited) => {
  const transitions = {
    backgroundSize: {
      duration: DURATION2.slow,
      ease: EASING.out
    },
    backdropFilter: {
      ease: EASING.out,
      duration: DURATION2.normal
    },
    opacity: {
      duration: DURATION2.normal,
      ease: EASING.inOut
    },
    maskImage: {
      duration: DURATION2.fast,
      ease: EASING.out
    }
  };
  const baseVariants = {
    open: {
      backgroundSize: "4px 4px",
      backdropFilter: "brightness(0.7) blur(3px)",
      opacity: 1
    },
    closed: {
      backgroundSize: "3px 3px",
      backdropFilter: "brightness(1) blur(5px)",
      opacity: 0
    }
  };
  if (coords === void 0 || maskType === void 0) {
    return {
      open: { ...baseVariants.open },
      closed: { ...baseVariants.closed }
    };
  }
  if (maskType === "origin") {
    return {
      open: ({ x, y }) => ({
        ...baseVariants.open,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
        transition: {
          ...transitions,
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.in
          }
        }
      }),
      closed: ({ x, y }) => ({
        ...baseVariants.closed,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 100%, rgba(0,0,0,1) 100%, rgba(0,0,0,1) 100%)`,
        transition: {
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.out
          }
        }
      })
    };
  }
  return {
    open: ({ x, y }) => {
      if (exited) {
        return {
          ...baseVariants.open,
          maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
          transition: {
            ...transitions,
            maskImage: {
              duration: DURATION2.slow,
              ease: EASING.in
            }
          }
        };
      }
      return {
        ...baseVariants.open,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
        transition: {
          ...transitions,
          maskImage: {
            duration: DURATION2.instant
          }
        }
      };
    },
    closed: ({ x, y }) => {
      if (exited) {
        return {
          ...baseVariants.closed,
          maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
          transition: {
            maskImage: {
              duration: DURATION2.slow,
              ease: EASING.out
            }
          }
        };
      }
      return {
        ...baseVariants.closed,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 100%, rgba(0,0,0,1) 100%, rgba(0,0,0,1) 100%)`,
        transition: {
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.out
          }
        }
      };
    }
  };
};
var ScrollContainer = React5.forwardRef(({ className, ...props }, ref) => {
  const { root } = scrollContainer({ size: "element" });
  return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
});
ScrollContainer.displayName = "ScrollContainer";

// src/components/banner/index.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var getBannerStatus = (value) => {
  if (!value) return "info";
  if (value.success === true) return "success";
  if (value.severity === "fatal") return "fatal";
  if (value.severity === "nonfatal") return "error";
  if (value.intent === "object") return "warning";
  if (value.intent === "confirm") return "info";
  return "info";
};
var Banner = ({ value }) => {
  const status = getBannerStatus(value);
  const { root: classes, action: actionClasses } = banner({ status });
  const Badge = (() => {
    switch (status) {
      case "success":
        return CheckCircleIcon;
      case "warning":
        return WarningIcon;
      case "fatal":
        return SmileyXEyesIcon;
      case "error":
        return XCircleIcon;
      case "info":
        return InfoIcon;
      default:
        return InfoIcon;
    }
  })();
  return /* @__PURE__ */ jsx6(AnimatePresence, { mode: "popLayout", children: value && /* @__PURE__ */ jsxs4(
    motion4.article,
    {
      className: classes,
      role: "region",
      "aria-live": "polite",
      variants: variants2[status === "success" ? "ok" : "error"],
      initial: "hidden",
      animate: "visible",
      exit: "hidden",
      transition: {
        clipPath: { duration: 0.6, ease: "easeInOut" },
        opacity: { duration: 0.3 }
      },
      children: [
        /* @__PURE__ */ jsxs4(Stack, { children: [
          /* @__PURE__ */ jsxs4(Inline, { justify: "between", children: [
            value.title ? /* @__PURE__ */ jsx6("strong", { children: value.title }) : null,
            /* @__PURE__ */ jsx6(Badge, { "data-icon-status": true, weight: "bold" })
          ] }),
          value.message ? /* @__PURE__ */ jsx6(Body, { children: value.message }) : null,
          typeof value.progress === "number" ? /* @__PURE__ */ jsx6("div", { style: { marginTop: "8px" }, children: /* @__PURE__ */ jsx6(
            "div",
            {
              style: {
                width: "100%",
                height: "4px",
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: "2px",
                overflow: "hidden"
              },
              role: "progressbar",
              "aria-valuenow": value.progress,
              "aria-valuemin": 0,
              "aria-valuemax": 100,
              "aria-label": `Progress: ${value.progress}%`,
              children: /* @__PURE__ */ jsx6(
                motion4.div,
                {
                  initial: { width: 0 },
                  animate: { width: `${value.progress}%` },
                  transition: { duration: 0.3 },
                  style: {
                    height: "100%",
                    backgroundColor: "currentColor",
                    opacity: 0.6
                  }
                }
              )
            }
          ) }) : null
        ] }),
        value.actions?.length ? /* @__PURE__ */ jsx6("div", { className: actionClasses, children: value.actions.map((action, index) => {
          const button2 = /* @__PURE__ */ jsx6(button_default, { emphasis: "subtle", onClick: action.onClick, disabled: action.disabled, children: action.label });
          return action.tooltip ? /* @__PURE__ */ jsxs4(tooltip_default, { children: [
            /* @__PURE__ */ jsx6(tooltip_default.Trigger, { children: button2 }),
            /* @__PURE__ */ jsx6(tooltip_default.Content, { children: action.tooltip })
          ] }, index) : /* @__PURE__ */ jsx6(React6.Fragment, { children: button2 }, index);
        }) }) : null
      ]
    },
    value.id ?? value.origin.id
  ) });
};
Banner.displayName = "Banner";
var banner_default = Banner;
var variants2 = {
  ok: {
    hidden: {
      clipPath: "circle(0% at 0% 0%)",
      opacity: 0
    },
    visible: {
      clipPath: "circle(150% at 0% 0%)",
      opacity: 1
    }
  },
  error: {
    hidden: {
      x: 0,
      opacity: 0
    },
    visible: {
      x: [-10, 10, -10, 10, -5, 5, 0],
      opacity: 1
    }
  }
};
export {
  banner_default as default
};
//# sourceMappingURL=banner.js.map